<template>
    <div style="background-color: white;">
        <div style="padding: 20px; display: flex; flex-direction: column;">
            <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">体检人员：</div>
            <div v-for="item in memberList" :key="item.memberId" style="margin-bottom: 10px;">{{item.joinRelation}}：<span style="float: right">{{item.joinName}}</span></div>
        </div>
        <div style="padding: 20px; display: flex; flex-direction: column;">
            <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">订单信息：</div>
            <div>收款方：<span style="float: right">{{ info.prodKind === '1' ? '诚泰财产保险股份有限公司' : '益保（北京）科技有限公司'}}</span></div>
            <div style="margin: 10px 0;">订单号：<span style="float: right">{{account.outTradeNo}}</span></div>
            <div>商品名称：<span style="float: right">{{info.prodName}}</span></div>
            <div style="margin: 10px 0;">购买单价：<span style="float: right">{{account.price}}元</span></div>
            <div>参保人数：<span style="float: right">{{count}}</span></div>
            <div style="margin: 10px 0;">共计：<span style="float: right">{{account.amount / 100}}元</span></div>
            <van-button type="info" style="align-self: center; margin-top: 10px;" @click="pay">确认信息并支付</van-button>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import {isWxBrowser} from '@/utils/commonUtils'

    export default {
        name: "Order",
        data() {
            return {
                info: {},
                account: {},
                count: {},
                payParams: {},
                memberList: []
            }
        },
        created() {
            this.payInfo()
            this.payCheck()
        },
        methods: {
            async payInfo() {
                let res = await this.$axios.get('buy/info', {
                    params: {
                        tradeNo: this.$route.query.tradeNo,
                        productId: this.$route.query.productId
                    }
                })
                if (res && res.code === 200) {
                    this.info = res.data.info
                    this.account = res.data.account
                    this.count = res.data.count
                    this.memberList = res.data.member
                }
            },
            payCheck() {
                if (!isWxBrowser()) {
                    this.$dialog.alert({
                        message: '请在微信中打开链接进行支付',
                        confirmButtonText: '确定'
                    });
                }
            },
            async pay() {
                this.payCheck()

                let res = await this.$axios.get('/wx/pay', {
                    params: {
                        tradeNo: this.$route.query.tradeNo,
                        productId: this.$route.query.productId,
                        totalPrice: this.account.amount
                    }
                })
                if (res && res.code === 200) {
                    this.payParams = res.data
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                        }
                    } else {
                        this.onBridgeReady();
                    }
                }
            },
            onBridgeReady() {
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    this.payParams,
                    (res) => {
                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                            // 使用以上方式判断前端返回,微信团队郑重提示：
                            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                            this.$notify({type: 'success', message: '支付成功'});
                            this.$router.push('/home')
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
